import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LocalStorageService } from '../../../xform-compat';
import { DateTime } from 'luxon';
import { CONFIG } from '../../../config';
interface ErrorModel {
  sourceUrl: string;
  message?: string;
  stackTrace: string;
  date?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerGlobalTrackerService {

  private url = '/api/rms/notifications/notifyerror';
  private currentBatch: Array<ErrorModel>;
  private dateFormat = 'M/d/yyyy, h:mm:ss';
  private currentDate: string;
  private tenMinutesAgo: any;
  private incomingError: ErrorModel;

  constructor(
    private http: HttpClient,
    private localStorageService: LocalStorageService
  ) {
    this.currentBatch = [];
  }

  /**
   * Receives the error params and post the error details
   * @param obj
   */
  public trackErrorException (obj: ErrorModel): void {

    this.incomingError = obj;
    this.currentDate = DateTime.now().toFormat(this.dateFormat);
    this.currentBatch = this.localStorageService.get('errorLog');

    if (!this.currentBatch) {
      this.currentBatch = [{ sourceUrl: obj.sourceUrl, date: this.currentDate, stackTrace: obj.stackTrace }];
      this.storeAndSaveBatch();
      return;
    }

    // get error Date less 10 minutes and convert to Date obj timestamp
    this.tenMinutesAgo = DateTime.fromFormat(this.currentDate, this.dateFormat)
      .minus({ minutes: 10 })
      .toJSDate()
      .getTime();
    // if incoming error is in batch and its expired: replace. otherwise: ignored
    for (let index = 0; index < this.currentBatch.length; index++) {
      // if finds out an expired error: replace, otherwhise: if batch <= 10, add error to batch
      if (this.currentBatch[index].sourceUrl === obj.sourceUrl) {
        if ((new Date(this.currentBatch[index].date).getTime() - this.tenMinutesAgo) <= 0) {
         this.currentBatch[index] = { sourceUrl: obj.sourceUrl, date: this.currentDate, stackTrace: obj.stackTrace };
         this.storeAndSaveBatch();
        }
        return;
      }
    }
    // add error if its a new one and there is enough space in batch. otherwise, finds out for an expired error and replace.
    if (this.currentBatch.length < 11) {
      this.currentBatch.push({ sourceUrl: obj.sourceUrl, date: this.currentDate, stackTrace: obj.stackTrace});
      this.storeAndSaveBatch();
    }
  }
  /**
   * save current batch of errors in local storage, and then post the error data.
   * @returns void
   */
  private storeAndSaveBatch(): void {
    this.localStorageService.set('errorLog', this.currentBatch);
    if (CONFIG.enableServerEmailLogging) {
      this.http.post(`${this.url}`, this.incomingError).subscribe(() => {});
    }
  }

}
